import { CommonModule, DOCUMENT, NgOptimizedImage } from '@angular/common'
import { Component, effect, Inject, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatTabsModule } from '@angular/material/tabs'
import { SkeletonComponent } from '@shared/components/skeleton/skeleton.component'
import { cdnUrl } from '../../app.module'
import { iranHotelsService } from './iran-hotels.service'
import {
  IHOBadgeModule,
  IHOBreadcrumbModule,
  IHOButtonModule,
  IHOCardModule,
  IHOFooterModule,
  IHOInputModule,
  IHONavbarModule,
  IHOTabModule,
} from 'design-system';
import { RecursiveDestinationsComponent } from './recursive-destinations/recursive-destinations.component'
import { State } from '@core/models/DTOs/hotel.dto'

@Component({
  selector: 'iho-iran-hotels',
  templateUrl: './iran-hotels.component.html',
  styleUrls: ['./iran-hotels.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatTabsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatButtonToggleModule,
    SkeletonComponent,
    IHOInputModule,
    NgOptimizedImage,
    RecursiveDestinationsComponent
]
})

export class iranHotelsComponent  {
  repo = inject(iranHotelsService);
  cdnUrl = cdnUrl;
  inputModel:any;
  showIcon: boolean[] = [];
  loading = true
  allStates:any;
  filteredStates: State[] | undefined = [];
  searchTerm = '';
  constructor(  
       @Inject(DOCUMENT) private document: Document,
      ) {
    effect(() => {
      
      if (this.repo.cityState()) {
        this.filteredStates = this.repo.cityState()?.StatesCitiesRegions;
        this.allStates = this.filteredStates;
      }
    });
  }


  showMore(index:number,ev:Event) {
    (this.document as any).querySelector(`.showMore-${index}`).previousElementSibling.classList.toggle('max-h-72');
    this.showIcon[index] = !this.showIcon[index];
  }
  onSearchCity(term: any) {
    this.searchTerm = term.target.value.trim();

    if (!term) {
      // اگر چیزی تایپ نشده همه چیز را نشان بده
      this.filteredStates = [...this.allStates];
      return;
    }

    const lower = this.searchTerm.toLowerCase();

    // هر State را فیلتر می‌کنیم تا فقط شهرهای مطابق باقی بمانند
    this.filteredStates = this.allStates
      .map((state:any) => ({
        
        ...state,
        Cities: state.Cities.filter((c:any) => c.CityTitle.toLowerCase().includes(lower))
      }))
      .filter((state:any) => state.Cities.length > 0); // فقط استان‌هایی که شهر منطبق دارند
  }

}
